import { useMutation } from '@tanstack/react-query';
import api from '@api/http/api';

export function useCollectGuideMutation() {
  return useMutation<{ success: true }>({
    mutationFn: () => api.post('/guide/collect'),
  });
}
